import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  redirect: '/loading',
  meta: {
    keepAlive: true
  },
},
/**
 * 加载过渡页
 */
{
  path: '/loading',
  name: 'loading',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/loading.vue')
},
/**
 * 首页
 */
{
  path: '/home',
  name: 'home',
  meta: {
    keepAlive: true
  },
  component: () => import('../views/home.vue')
},
/**
 * 捐赠页面
 */
{
  path: '/donate',
  name: 'donate',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/donate.vue')
},
{
  path: '/my-donation',
  name: 'my-donation',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/my-donation.vue')
},
{
  path: '/donation-ranking',
  name: 'donation-ranking',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/donation-ranking.vue')
},
  // 以下路由页面暂未创建，后续按需添加
  // {
  //   path: '/booking',
  //   name: 'booking',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/booking/booking-form.vue')
  // },
  // {
  //   path: '/booking/result',
  //   name: 'booking-result',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/booking/booking-result.vue')
  // },
  // {
  //   path: '/service',
  //   name: 'service-list',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/service/service-list.vue')
  // },
  // {
  //   path: '/service/detail',
  //   name: 'service-detail',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/service/service-detail.vue')
  // },
  // {
  //   path: '/service/order',
  //   name: 'service-order',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/service/service-order.vue')
  // },
  // {
  //   path: '/payment',
  //   name: 'payment-query',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/payment/payment-query.vue')
  // },
  // {
  //   path: '/payment/bill',
  //   name: 'payment-bill',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/payment/payment-bill.vue')
  // },
  // {
  //   path: '/expiry',
  //   name: 'expiry-query',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/expiry/expiry-query.vue')
  // },
  // {
  //   path: '/mall',
  //   name: 'mall-index',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/mall/mall-index.vue')
  // },
  // {
  //   path: '/mall/detail',
  //   name: 'mall-detail',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/mall/mall-detail.vue')
  // },
  // {
  //   path: '/memorial',
  //   name: 'memorial-square',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/memorial/memorial-square.vue')
  // },
  // {
  //   path: '/memorial/hall',
  //   name: 'memorial-hall',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/memorial/memorial-hall.vue')
  // },
  // {
  //   path: '/memorial/create',
  //   name: 'memorial-create',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/memorial/memorial-create.vue')
  // },
  // {
  //   path: '/user',
  //   name: 'user-center',
  //   meta: { keepAlive: true },
  //   component: () => import('../views/user/user-center.vue')
  // },
  // {
  //   path: '/user/memorial',
  //   name: 'my-memorial',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/user/my-memorial.vue')
  // },
  // {
  //   path: '/user/booking',
  //   name: 'booking-record',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/user/booking-record.vue')
  // },
  // {
  //   path: '/user/payment',
  //   name: 'payment-record',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/user/payment-record.vue')
  // },
  // {
  //   path: '/user/service-order',
  //   name: 'service-order-list',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/user/service-order.vue')
  // },
  // {
  //   path: '/user/mall-order',
  //   name: 'mall-order-list',
  //   meta: { keepAlive: false },
  //   component: () => import('../views/user/mall-order.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
